import {Container} from 'components/atoms/Layout/Container';
import {P} from 'components/atoms/Text/P';
import {SiteSpecificContent} from 'components/atoms/SiteSpecificContent';
import {ContactCard} from 'components/molecules/ContactCard';
import {Margin, ParagraphSize, SITE, HeadlineLevel} from 'features/ui/enums';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import './_notAvailable.scss';
import { useDeviceStore, selectIsMobile } from 'features/ui/store/useDeviceStore';
import { useBuyResidenceStore, selectCurrentObject } from 'features/buyResidence/store/useBuyResidenceStore';
import {Headline} from '@atoms/Text/Headline';

export const NotAvailable: React.FunctionComponent = ({}) => {

    const _isMobile = useDeviceStore(selectIsMobile);
    const currentObject = useBuyResidenceStore(selectCurrentObject);

    return (
        <div className="not-available">
            <Container narrow className="click-to-buy-info-page__contact" id="click-to-buy-info-contact-block">
            <Headline level={HeadlineLevel.H3} margin={Margin.L}>
                <SiteSpecificContent sites={[SITE.SV, SITE.BORATT, SITE.SENIORGARDEN, SITE.FI]}>
                    <FormattedMessage id="jm.components.organisms.BuyResidence.NotAvailable.title" values={{ apartmentNumber: currentObject?.objectNumber, stageName: currentObject?.stageName }} />
                </SiteSpecificContent>
                <SiteSpecificContent showOnNorway>
                    Boligen er allerede foreløpig reservert av en annen kjøper
                </SiteSpecificContent>
            </Headline>

            <P size={ParagraphSize.L}>
                <SiteSpecificContent sites={[SITE.SV, SITE.BORATT, SITE.SENIORGARDEN, SITE.FI]}>
                    <FormattedMessage id="jm.components.organisms.BuyResidence.NotAvailable.subtitle" values={{ brokerPhone: currentObject?.brokerPhone, brokerName: currentObject?.brokerName }}  />
                </SiteSpecificContent>
                <SiteSpecificContent showOnNorway>
                    Kontakt megleren {currentObject?.brokerName}, {currentObject?.brokerPhone} for mer informasjon
                </SiteSpecificContent>
            </P>

            {currentObject?.brokerName &&
                    <div className="click-to-buy-info-page__contact__box">
                        <ContactCard
                            img={currentObject?.brokerImageUrl}
                            name={currentObject?.brokerName}
                            title=""
                            company=""
                            phone={currentObject?.brokerPhone}
                            mail={currentObject?.brokerEmail}
                        />
                    </div>
            }
            </Container>

        </div>
    );
};
